import cleanedFilename from '~/util/cleanedFilename';

export default {
  IMG_ELEMENT: `${cleanedFilename(__filename)}-img-element`,
  IMAGE_PLACHOLDER: `${cleanedFilename(__filename)}-image-placeholder`,
  DELETE_BUTTON: `${cleanedFilename(__filename)}-delete-button`,
};
